// @file Vue composable for PostHog
import environment from '@@/bits/environment'

const POSTHOG_TOKEN =
  environment === 'production'
    ? 'phc_Qq7IdaGdpavwycUT45k9GGcwMUjV1XIRx3zGRe1Nxrc'
    : 'phc_EPCt6qTBrd32zI0egjOAA8SoeriXYmG5y369SNYZNOh'

async function usePostHog() {
  const { posthog } = await import('posthog-js')
  posthog.init(POSTHOG_TOKEN, {
    api_host: 'https://echo.padlet.com',
    ui_host: 'https://us.posthog.com',
    autocapture: false,
    persistence: 'localStorage',
    person_profiles: 'identified_only',
  })

  return { posthog }
}

export { usePostHog }
